import { useEffect } from 'react';

const VERSION_CHECK_INTERVAL = 60 * 1000;
const VERSION_STORAGE_KEY = 'app_version';

const fetchLatestVersion = async () => {
  try {
    const response = await fetch(`/version.json?_=${Date.now()}`, {
      cache: 'no-store',
      headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' },
    });
    if (!response.ok) return null;
    return await response.json();
  } catch (err) {
    return null;
  }
};

const useVersionCheck = () => {
  useEffect(() => {
    let cancelled = false;

    const checkVersion = async () => {
      const latest = await fetchLatestVersion();
      if (!latest || cancelled) return;

      const stored = sessionStorage.getItem(VERSION_STORAGE_KEY);
      const current = latest.buildTime || latest.version;

      if (!stored) {
        sessionStorage.setItem(VERSION_STORAGE_KEY, current);
        return;
      }

      if (stored !== current) {
        console.log('[version] Có bản mới, tải lại trang...', { stored, current });
        sessionStorage.setItem(VERSION_STORAGE_KEY, current);
        window.location.reload();
      }
    };

    checkVersion();
    const interval = setInterval(checkVersion, VERSION_CHECK_INTERVAL);

    const handleVisibility = () => {
      if (document.visibilityState === 'visible') checkVersion();
    };
    document.addEventListener('visibilitychange', handleVisibility);

    return () => {
      cancelled = true;
      clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, []);
};

export default useVersionCheck;
